export const flash = {
  namespaced: true,
  state: {
    type: null,
    message: null,
  },
  mutations: {
    updateFlash(state, payload) {
      state.type = payload.type
      state.message = payload.message
    },
    clearFlash(state) {
      state.type = null
      state.message = null
    },
  },
  actions: {
    updateFlash({ commit }, payload) {
      commit('updateFlash', payload)
    },
    clearFlash({ commit }) {
      commit('clearFlash')
    },
  }
}
